/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Loading, InlineNotification } from 'carbon-components-react';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import './InstancesUpdating.scss';

const messages = defineMessages({
  updating: {
    id: 'modules.ia.components.Instances.InstancesUpdating.updating',
    defaultMessage: 'Updating list of instances...'
  }
});

const InstancesUpdating = () => {
  const intl = useIntl();

  return (
    <div className="InstancesUpdating">
      <InlineNotification
        className="InstancesList__loading-notification"
        kind="info"
        hideCloseButton
        title={intl.formatMessage(messages.updating)}
        subtitle={<Loading small withOverlay={false} />}
      />
    </div>
  );
};

export default InstancesUpdating;
